const getBenchmarkingSelectedFilters = ({ report: { benchmarkingFilters } }) => ({
  selectedFilters: benchmarkingFilters.selected,
  selectedFiltersUrlParams: benchmarkingFilters.urlParams,
});

export default getBenchmarkingSelectedFilters;
